import Navbar from "./Navbar";
import Slideshow from "./Sections/Slideshow";

const Header = () => {
  return (
    <header
      className="relative bg-gradient-to-b from-cyan-200 to-blue-500"
      //   className="relative flex-col bg-header items-center justify-center
      // bg-cover bg-center md:bg-fixed md:bg-no-repeat"
    >
      <Slideshow />
      <div className="absolute inset-0 z-10">
        <Navbar />
        <div className="flex flex-col justify-center items-center px-4 sm:py-12 mt-32 text-white text-5xl">
          <div>
            <span>Bienvenue sur le site </span>
            <div>
              <span className="sm:hidden">du cabinet de kinésithérapie.</span>
            </div>
          </div>
          <div className="mt-4">
            <span
              className="hidden sm:flex bg-white text-gray-900  px-4"
              style={{
                clipPath: "polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)",
              }}
            >
              du cabinet de kinésithérapie.
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
